.nav-drawer {
  --drawer-bg-color: var(--go-color-lightest);
  --drawer-max-width: 24rem;
  --nav-item-text-color: var(--go-color-darkest);
  --nav-item-bg-color: var(--go-color-lightest);
  --nav-item-hover-bg-color: var(--go-color-neutral-200);
  --nav-item-padding: var(--go-size--1) var(--go-size-0);
  --nav-header-padding: var(--go-size--1) var(--go-size-0);
  --nav-header-border-color: var(--go-color-neutral-200);
  --nav-item-icon-gap: var(--go-size-0);
  --nav-item-current-bar-width: 4px;
  --nav-item-current-bar-color: var(--go-color-primary-500);
  --submenu-parent-link-border-bottom: 1px solid var(--go-color-neutral-200);

  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--layer-important);
  background: var(--drawer-bg-color);
  transform: translateX(-100%);
  @include transition(transform);
  @include reduced-motion {
    transition-duration: 0s;
  }

  @include tablet {
    width: var(--drawer-max-width);
  }

  &.right {
    left: auto;
    right: 0;
    transform: translateX(100%);
  }
  &.open {
    transform: translateX(0);
  }

  .nav-container {
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .nav-menu {
    @include transition(transform, visibility);
    @include reduced-motion {
      transition-duration: 0s;
    }

    visibility: visible;
    transform: translateX(0);
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    background: var(--drawer-bg-color);
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .nav-drawer-header {
      .header-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--nav-header-padding);
        .back-btn {
          margin-right: auto;
        }
        .close-btn {
          margin-left: auto;
          flex: 0 0 auto;
        }
        .title {
          font-weight: bold;
          font-size: var(--go-size-0);
          flex: 1;
        }
      }
    }

    &.is-sub-nav {
      .nav-drawer-header {
        .title {
          margin-left: 1rem;
        }
      }
    }

    nav {
      border-top: 2px solid var(--nav-header-border-color);
      height: 100%;
      padding: 1rem 0;
      flex: 1;
      overflow: auto;
    }

    .nav-menu {
      box-shadow: var(--shadow-4);
      visibility: hidden;
      transform: translateX(100%);
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .nav-item-inner {
    @include reset-btn;

    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--nav-item-padding);
    color: var(--nav-item-text-color);
    text-decoration: none;
    background: var(--nav-item-bg-color);
    border-left: var(--nav-item-current-bar-width) solid transparent;
    &:hover,
    &:focus {
      background: var(--nav-item-hover-bg-color);
    }
  }

  .nav-item-label {
    display: flex;
    align-items: center;
    gap: var(--nav-item-icon-gap);
  }

  .children-indicator {
    width: 1.5em;
    height: 1.5em;
  }

  // mobile menu item
  li {
    padding: 0;
    line-height: 1.5;

    &.active {
      > .nav-menu {
        visibility: visible;
        transform: translateX(0);
        z-index: 2;
      }
    }

    &.current {
      > .nav-item-inner {
        border-left-color: var(--nav-item-current-bar-color);
      }
    }
  }

  .parent-link {
    border-bottom: var(--submenu-parent-link-border-bottom);
    a {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      padding: var(--nav-item-padding);
      color: var(--nav-item-text-color);
      text-decoration: none;
      background: var(--nav-item-bg-color);
      font-weight: bold;
      border-left: var(--nav-item-current-bar-width) solid transparent;
      svg {
        @include transition(transform);

        margin-left: 0.5rem;
        width: 1.25em;
        height: 1.25em;
        transform: translateX(0);
      }
      &:hover,
      &:focus {
        background: var(--nav-item-hover-bg-color);
        svg {
          transform: translateX(5px);
        }
      }
    }
  }
}
